


























import { TTabsItem } from '@/api/schema';
import VTabsHash from '@/components/VTabsHash.vue';
import { mapState } from 'vuex';

export enum EAutoclickerTabsKeys {
  AUTOCLICKER = 'autoclicker',
  GAMES_FOR_AUTOCLICKER = 'games-for-autoclicker',
  JOB_MANAGEMENT = 'job-management'
}

export default {
  name: 'CopyStakeAutoclickerTabs',
  components: {
    VTabsHash,
    CopyStakeAutoclickerTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAutoclicker/Autoclicker/CopyStakeAutoclickerTab.vue'
      ),
    CopyStakeGamesForAutoclickerTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAutoclicker/GamesForAutoclicker/CopyStakeGamesForAutoclickerTab.vue'
      ),
    CopyStakeJobManagementTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAutoclicker/JobManagement/CopyStakeJobManagementTab.vue'
      )
  },
  data(): any {
    return {
      currentTab: 0
    };
  },
  computed: {
    ...mapState('app', ['isSuperAdmin']),
    tabs(): TTabsItem[] {
      return [
        {
          id: EAutoclickerTabsKeys.AUTOCLICKER,
          text: 'Autoclicker',
          component: 'CopyStakeAutoclickerTab',
          visible: true
        },
        {
          id: EAutoclickerTabsKeys.GAMES_FOR_AUTOCLICKER,
          text: 'Games for Autoclicker',
          component: 'CopyStakeGamesForAutoclickerTab',
          visible: this.isSuperAdmin
        },
        {
          id: EAutoclickerTabsKeys.JOB_MANAGEMENT,
          text: 'Job Management',
          component: 'CopyStakeJobManagementTab',
          visible: true
        }
      ].filter(({ visible }) => visible);
    }
  }
};
